import {PredefinedBaseConfiguration} from './PredefinedBaseConfiguration';
import {SqlParam} from '../../sql/message/SqlParam';

export class StoredProcConfiguration extends PredefinedBaseConfiguration {
cnxCode: string;
exitStatusOnSuccess: boolean | null;
name: string;
params: SqlParam[];
schema: string;
targetEngineValue: string;
}

